import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BillState } from './bill.types';
import { BillModel } from '../../models/bill';

const initialState: BillState = {
  bills: [],
  error: null,
  loading: false,
};

const billSlice = createSlice({
  name: 'bill',
  initialState,
  reducers: {
    billUpdated: (state, action: PayloadAction<BillModel[]>) => {
      state.bills = action.payload;
      state.loading = false;
      state.error = null;
    },
    billListenerError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetBill: (state) => {
      state.bills = [];
      state.loading = false;
      state.error = null;
    },
  }
});

export const {
  billUpdated,
  billListenerError,
  resetBill,
} = billSlice.actions;
export default billSlice.reducer;
